import { useDateFormatter, useTranslator } from '@bluebeam/react-i18n';
import Calendar from 'components/Icons/Calendar';
import React, { ReactElement } from 'react';
import { Project } from 'records/Project';
import { Punch } from 'records/Punch';

const tempStatusColors = {
  OPEN: '#ff8585',
  READY_FOR_REVIEW: '#ffb985',
  OUT_OF_SCOPE: '#ddd',
  CLOSED: '#ddd',
};

interface Props {
  punch: Punch;
  project: Project;
  onPunchListRowClick: (punch: Punch) => void;
}

const PunchListRow = (props: Props): ReactElement => {
  const { translate } = useTranslator(['statusLabels']);

  const { punch, project, onPunchListRowClick } = props;

  const status = project.statuses.find((s) => s.status === punch.status);
  const statusKey: `${string}:${string}` =
    `statusLabels:statuses.${status?.status}` as `${string}:${string}`;

  const translatedStatus = translate(statusKey);
  const pastDueDate = punch.duedate !== 0 && punch.duedate < Date.now() / 1000;

  const dateFormatter = useDateFormatter({
    dateStyle: 'medium',
  });

  return (
    <div
      className="bb-2 color-gray-7 bgd-gray-2-h cursor-pointer py3 px4"
      id={`punch-list-item-${punch.id}`}
      onClick={(): void => onPunchListRowClick(punch)}
    >
      <div className="column">
        <div className="font-size-7 medium mb2">{punch.location}</div>
        <div className="mb3 font-size-5 regular truncate">
          {punch.description}
        </div>
        <div className="row justify-between">
          <div
            className="bold b-radius-3 px2 py1 color-gray-8"
            style={{
              backgroundColor: tempStatusColors[status?.status || 'OPEN'],
            }}
          >
            {`${punch.number} - ${translatedStatus}`}
          </div>
          <div
            className="row items-center"
            style={{
              color: pastDueDate ? 'var(--color-error)' : 'initial',
            }}
          >
            {punch.duedate !== 0 && (
              <>
                <div className="mr1 wrem-1p5 hrem-1p5 flex-center">
                  <Calendar width="16px" height="16px" />
                </div>
                {dateFormatter?.format(new Date(punch.duedate * 1000))}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PunchListRow;
